import { use, useState } from 'react';

import OrganisationUnitScenario from 'features/residents/models/organisation-unit-scenario';
import ResidentSettingsProviderContext from 'features/residents/resident-settings/providers/contexts/resident-settings-provider-context';

type ResidentSettingDetailsScenariosAccordion = {
  shouldShowScenarios: boolean;
  hasScenarios: boolean | undefined;
  toggleShouldShowScenarios: () => void;
  organisationUnitScenarios: OrganisationUnitScenario[] | undefined;
};

const useResidentSettingDetailsScenariosAccordion = (): ResidentSettingDetailsScenariosAccordion => {
  const {
    detailEditState: { currentResidentSetting, residentSettingEditForm, viewingMode },
  } = use(ResidentSettingsProviderContext);

  const [shouldShowScenarios, setShouldShowScenarios] = useState<boolean>(false);

  const toggleShouldShowScenarios = () => setShouldShowScenarios(!shouldShowScenarios);

  const organizationUnitScenariosWatch = residentSettingEditForm.watch('organisationUnitScenarios');

  const hasScenarios =
    organizationUnitScenariosWatch && currentResidentSetting && currentResidentSetting.organisationUnitScenarios.length > 0;

  const organisationUnitScenarios =
    viewingMode === 'viewing'
      ? currentResidentSetting?.organisationUnitScenarios
      : residentSettingEditForm.getValues('organisationUnitScenarios');

  return {
    shouldShowScenarios,
    hasScenarios,
    toggleShouldShowScenarios,
    organisationUnitScenarios,
  };
};

export default useResidentSettingDetailsScenariosAccordion;
